import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ApiResponseCode, LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { authenticateErrorAction, AuthenticationActionTypes } from '../+state';
import { TokenResult } from '../models';
import { BaseHandler } from './base.handler';

export class PasswordExpiredHandler extends BaseHandler {
  public handle(response: LoyaltyResponse<TokenResult>): TypedAction<AuthenticationActionTypes> {
    if (response.soloResponseCode === ApiResponseCode.Account_Password_Expired) {
      const failure = new AppStateFailureBuilder()
        .setFailureType(FailureType.Validation)
        .addFailure(new AppStateFailureItemWithErrorCode('Password Expired', ApiResponseCode.Account_Password_Expired))
        .build();
      return authenticateErrorAction({ failure });
    }
    return this.nextHandler.handle(response);
  }
}
